import React, {useState} from "react";
import downArrow from "../../Forexs/assets/downArrow.png";
import topArrow from "../../Forexs/assets/topArrow.png";
import green from "../assets/greeb.png";
import redGrap from "../assets/red.png";
import close from "../assets/x.png";
const SingleReport = ({ red, title, setData, i }) => {
  const handleDelete = () => {
    setData((pre) => pre.filter((single, index) => i !== index));
  };
  return (
    <div>
      <div className="pl-[15px] relative flex items-center justify-between pt-[11px] pb-[13px] pr-[22px] gap-2  h-[40px] bg-[#2A2D37] rounded-[5px]">
        <button
          onClick={handleDelete}
          className={`absolute flex justify-center items-center rounded-[3px] translate-x-1/2 -translate-y-1/2 right-0 top-0 h-[18px] w-[18px] cursor-pointer ${
            red ? "bg-[#FB3F3F]" : "bg-main-green"
          }`}
        >
          <img src={close} alt="close" />
        </button>
        <div className="flex items-center">
          <div
            className={`w-[30px]  h-[20px]    flex justify-center items-center rounded-[7px] ${
              red ? "bg-[#FB3F3F]" : "bg-main-green"
            }`}
          >
            <img
              className="w-[10px]"
              src={red ? downArrow : topArrow}
              alt="arrow"
            />
          </div>
          <h2 className="uppercase text-xxs font-semibold  md:text-res-sm ml-[8px] md:min-w-[107px] md:max-w-[107px] md:ml-[20px] whitespace-nowrap">
            btc{" "}
            <span className={`${red ? "text-[#FB3F3F]" : "text-main-green"}`}>
              {title}
            </span>
          </h2>
        </div>
        <h2 className=" text-xxs md:text-res-sm font-semibold grow w-full text-center">
          $27,482.55
        </h2>
        <div className="flex  justify-end ">
          <div className="md:w-[146px] flex  justify-end ">
            <img
              className="w-[60px]  md:w-auto"
              src={red ? redGrap : green}
              alt="chart"
            />
          </div>
        </div>
      </div>
      <div className=" bg-[#2A2D37] mt-[3px] rounded-[10px] relative ">
        <div className="flex justify-between">
          <button
            className={`text-[#2A2D37] font-bold text-res-xs w-[223px] ${
              red ? "bg-[#FB3F3F]" : "bg-main-green"
            } h-[26px] rounded-br-[10px] `}
          >
            Bitcoin Rally this week
          </button>
          <h4 className="mt-[17px] text-[12px] mr-[30px] font-bold">
            17th May, 2023
          </h4>
        </div>
        <div className="mt-[5px]  whitespace-pre-wrap pl-[19px] pr-[24px] pb-[17px]  leading-[20px] text-[13px] break-words  ">
          Bitcoin (BTC) has shown strong bullish momentum, breaking through key
          resistance levels and forming higher highs. The overal l market
          sentiment is positive, with increasing buying pressure. Technical
          indicators suggest a potential upward continuation in the short-term.
        </div>
        <button className="text-[#2A2D37] font-bold text-[12px] w-[114px] bg-[#CECECE] h-[17px] rounded-tl-[10px] rounded-br-[10px] absolute right-0 bottom-0">
          Read More
        </button>
      </div>
    </div>
  );
};

export default SingleReport;
